import BaseModal from "../../BaseComponents/BaseModal/BaseModal";
import styles from "./ViewPaymentModal.module.css";

const ViewPaymentModal = ({ open, onClose, payment, paymentType = "incoming" }) => {
  if (!payment) return null;

  const footer = (
    <button onClick={onClose} className={styles.closeBtn}>
      Close
    </button>
  );

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Payment Details"
      footer={footer}
      width="600px"
    >
      <div className={styles.content}>
        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>Payment Information</h4>
          <div className={styles.grid}>
            <div className={styles.field}>
              <span className={styles.label}>Payment Reference</span>
              <span className={styles.value}>{payment.reference}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.label}>Status</span>
              <span className={`${styles.value} ${styles[`status${payment.status}`]}`}>
                {payment.status}
              </span>
            </div>
            <div className={styles.field}>
              <span className={styles.label}>Amount</span>
              <span className={styles.value}>
                {payment.currency} {payment.amount.toLocaleString('en-US', { 
                  minimumFractionDigits: 2, 
                  maximumFractionDigits: 2 
                })}
              </span>
            </div>
            <div className={styles.field}>
              <span className={styles.label}>Payment Date</span>
              <span className={styles.value}>{payment.date}</span>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>Booking & {paymentType === "incoming" ? "Customer" : "Supplier"} Details</h4>
          <div className={styles.grid}>
            <div className={styles.field}>
              <span className={styles.label}>Booking Reference</span>
              <span className={styles.value}>{payment.bookingRef}</span>
            </div>
            {paymentType === "incoming" ? (
              <>
                <div className={styles.field}>
                  <span className={styles.label}>Customer Name</span>
                  <span className={styles.value}>{payment.customerName}</span>
                </div>
                {payment.customerEmail && (
                  <div className={styles.field}>
                    <span className={styles.label}>Customer Email</span>
                    <span className={styles.value}>{payment.customerEmail}</span>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className={styles.field}>
                  <span className={styles.label}>Supplier Name</span>
                  <span className={styles.value}>{payment.supplier || payment.supplierName}</span>
                </div>
                {payment.dueDate && (
                  <div className={styles.field}>
                    <span className={styles.label}>Due Date</span>
                    <span className={styles.value}>{payment.dueDate}</span>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>Payment Method & Account</h4>
          <div className={styles.grid}>
            <div className={styles.field}>
              <span className={styles.label}>Payment Method</span>
              <span className={styles.value}>{payment.paymentMethod}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.label}>Account</span>
              <span className={styles.value}>{payment.account}</span>
            </div>
          </div>
        </div>

        {(payment.airlinePnr || payment.supplierReferenceNo || payment.transactionId) && (
          <div className={styles.section}>
            <h4 className={styles.sectionTitle}>Reference Numbers</h4>
            <div className={styles.grid}>
              {payment.airlinePnr && (
                <div className={styles.field}>
                  <span className={styles.label}>Airline PNR</span>
                  <span className={styles.value}>{payment.airlinePnr}</span>
                </div>
              )}
              {payment.supplierReferenceNo && (
                <div className={styles.field}>
                  <span className={styles.label}>Supplier Reference No</span>
                  <span className={styles.value}>{payment.supplierReferenceNo}</span>
                </div>
              )}
              {payment.transactionId && (
                <div className={styles.field}>
                  <span className={styles.label}>Transaction ID</span>
                  <span className={styles.value}>{payment.transactionId}</span>
                </div>
              )}
            </div>
          </div>
        )}

        {payment.notes && (
          <div className={styles.section}>
            <h4 className={styles.sectionTitle}>Notes</h4>
            <div className={styles.notes}>
              {payment.notes}
            </div>
          </div>
        )}
      </div>
    </BaseModal>
  );
};

export default ViewPaymentModal;